export function setUsuario(usuario){
  return {
    type : "SET_USUARIO",
    usuario
  }
}